module.exports = __webpack_public_path__ + "img/gs.172d656b.svg";